export default __webpack_public_path__ + "51ba80c2184ebbabda19717e3f5cec98.wav";